if (!customElements.get('sfx-bundle-add')) {
  customElements.define('sfx-bundle-add', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      this.button.addEventListener('click', () => this.addBoth());
    }

    async addBoth() {
      if (this.button.disabled) return;
      const root = window.Shopify?.routes?.root || '/';
      const form = document.getElementById(this.dataset.productFormId);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      let language = document.documentElement.lang || 'es';
      try { language = localStorage.getItem('lang') || language; } catch (error) {}
      const lang = language.toLowerCase().startsWith('en') ? 'en'
        : language.toLowerCase().startsWith('fr') ? 'fr'
        : 'es';
      const fallbackError = lang === 'en' ? "We couldn't add both packs. Please try again."
        : lang === 'fr' ? "Nous n'avons pas pu ajouter les deux packs. Réessaie."
        : 'No pudimos agregar ambos packs. Probá de nuevo.';
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;

      try {
        if (!form) throw new Error(fallbackError);
        const data = new FormData(form);
        const variantId = Number(data.get('id'));
        const sfxId = Number(this.dataset.sfxVariantId);
        const quantity = Number(data.get('quantity') || 1);
        if (!variantId || !sfxId || !Number.isInteger(quantity) || quantity < 1) throw new Error(fallbackError);
        const primary = { id: variantId, quantity };
        const properties = {};
        for (const [key, value] of data.entries()) {
          const match = /^properties\[(.+)\]$/.exec(key);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) primary.properties = properties;
        if (data.get('selling_plan')) primary.selling_plan = data.get('selling_plan');
        const sections = cart?.getSectionsToRender().map(section => section.id) || [];
        if (cart?.setActiveElement) cart.setActiveElement(this.button);
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [primary, { id: sfxId, quantity }],
            sections,
            sections_url: window.location.pathname
          })
        });
        const added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || added.message || fallbackError);

        if (!cart || !sections.every(id => added.sections?.[id])) {
          window.location.assign(root + 'cart');
          return;
        }
        try {
          cart.classList.remove('is-empty');
          cart.renderContents(added);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sfx-bundle',
              productVariantId: String(variantId),
              cartData: added
            });
          }
        } catch (error) {
          window.location.assign(root + 'cart');
        }
      } catch (error) {
        this.error.textContent = error.message || fallbackError;
        this.error.hidden = false;
      } finally {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}
